
export const FormDataConfig = {
  headers: {
    'content-type': 'multipart/form-data',
  },
}